<!-- 안전리더십 > 리포트 > 제출파일 결과물보기 -->
<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="90rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.viewDeliverables')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <!--content-->
        <v-card-text>
          <div class="tbl-group line-ty size-custom20">
            <v-data-table
              :headers="headers"
              :items="fileList"
              hide-default-footer
              disable-sort
            >
              <template v-slot:item="{ item, index }">
                <tr class="v-data-table__tr">
                  <td>
                    <div class="txt-group">{{item.taskTitle}}</div>
                  </td>
                  <td>
                    <div class="txt-group">{{item.contentTitle}}</div>
                  </td>
                  <td>
                    <div class="txt-group flex-c">{{item.periodSeq}}{{t('message.round')}}</div>
                  </td>
                  <td>
                    <div class="txt-group flex-c">{{`${item.memberName??t('message.noInfo')}/${item.posName??t('message.noInfo')}/${item.deptName??t('message.noInfo')}`}}</div>
                  </td>
                  <td>
                    <div class="txt-group flex-c">{{dayjs(item.regDate.substring(0, 19)).format('YYYY-MM-DD HH:mm')}}</div>
                  </td>
                  <td>
                    <div class="txt-group flex-c">
                      <BtnIcon class="btn-ico-result" @click="onClickDownloadFile(item)"/>
                    </div>
                  </td>
                  <td v-if="false">
                    <div class="txt-group flex-c">
                      <div class="form-group">
                        <c-Input :placeholder="'0'"  class="inp-num" :name="'adminRating'" :disabled="!isReportAdmin && userInfo.roles == 'USER'"/>
                      </div>
                      <c-btn01 :btnText="t('message.save')" :btn-show="true" class="sm" v-if="isReportAdmin || userInfo.roles != 'USER'"/>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import utils from "@/common/Utils";
import _ from 'lodash';
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import { useI18n } from 'vue-i18n';
import dayjs from "dayjs";
const { t } = useI18n();

const emit = defineEmits(['close', 'confirm'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//UI
const headers = ref([
  { title: t('message.stepName'), key: 'stepName' },
  { title: t('message.subTaskName'), key: 'subTaskName' },
  { title: t('message.round'), key: 'round'},
  { title: t('message.registrant'), key: 'registrant' },
  { title: t('message.registrationDate'), key: 'registrationDate' },
  { title: t('message.viewDeliverables'), key: 'viewDeliverables' },
  //{ title: t('message.evaluatorScore'), key: 'evaluatorScore' },
])

//bind
const snackbar = ref(false)
const snackText = ref('')
const isReportAdmin:any = ref(false)
const userInfo = JSON.parse(localStorage.getItem('user'))

//compute
const fileList = computed(() => storeRef.fileList.value)

//hook
onBeforeUpdate (()=>{
})

onUpdated(() => {
  if(!dialog.value)
    return

  isReportAdmin.value = _.some((storeRef.leadershipInfo.value as any).reportTargets, {idx:userInfo.memberIdx})
})

//function
const onClickDownloadFile=async(item)=>{
  const url = utils.getBaseUrl('freeboard', item.filePath)
  const ext = url.split('.').pop()?.toLowerCase()
  const viewableExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'txt', 'html', 'htm', 'mp4', 'webm']
  if (ext && viewableExtensions.includes(ext)) {
    window.open(url, '_blank')
  } else {
    const res = await fetch(url, { credentials: 'include' })
    const blob = await res.blob()

    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = item.fileName || 'download'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(blobUrl)
  }
}

</script>


<style lang="scss">

</style>
